import { Rights } from '@frontend/common';
import React from 'react';

import { DefaultSelectProps } from '../basic-forms';
import { SelectInput } from '../select-input/select-input.component';

const ID = 'right-select';

export const RightSelect = (props: DefaultSelectProps) => {
    return (
        <SelectInput
            {...props}
            id={props.id || ID}
            isClearable={props.isClearable}
            className={props.className}
            options={Object.values(Rights).map((c) => ({ label: c, value: c }))}
            value={props.value}
            label={props.label || 'Right'}
            submitted={props.submitted}
            required={props.required}
            onChange={(value) => props.onChange && props.onChange((value as { label: string; value: string })?.value)}
        />
    );
};
